export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-gradient-to-br from-background-100 via-background-50 to-accent-50/60 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-bold mb-5">
              <i className="ri-fire-line text-sm"></i>
              实时爆料 · 每日更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
              51吃瓜在线
              <span className="block text-primary-600">你的随身八卦追剧神器</span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              汇聚全网最新最热的吃瓜视频内容，覆盖娱乐圈猛料、社会热点爆料、网红动态追踪等多个维度。每日 200+ 条新鲜视频上线，高清流畅播放体验，支持随时随地在线观看与在线播放，不错过任何一个精彩瞬间。
            </p>

            <p className="text-foreground-500 text-sm mb-6 max-w-xl mx-auto lg:mx-0">
              当前热门焦点：暑期档影视八卦密集爆发，综艺塌房连环瓜持续追踪，网红圈年度大戏正在上演。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-vidicon-line text-primary-500"></i>
                <span><strong className="text-foreground-900">200+</strong> 条/日更新</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-global-line text-primary-500"></i>
                <span>覆盖<strong className="text-foreground-900">全网</strong>热点</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-timer-line text-primary-500"></i>
                <span><strong className="text-foreground-900">全天候</strong>不间断</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => { e.preventDefault(); handleScroll('#media'); }}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-sm rounded-xl hover:bg-primary-600 transition-all duration-200 text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>立即吃瓜
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); handleScroll('#app'); }}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-800 font-bold text-sm rounded-xl border-2 border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 text-center"
              >
                <i className="ri-smartphone-line mr-2"></i>移动端看瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px]">
              <div className="relative rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Dynamic%20entertainment%20news%20collage%20with%20warm%20vibrant%20colors%2C%20celebrity%20gossip%20themed%20abstract%20composition%2C%20hot%20topic%20visual%20elements%2C%20modern%20social%20media%20aesthetic%2C%20eye-catching%20graphic%20design%20style%2C%20bold%20typography%20background%20elements%2C%20coral%20and%20amber%20color%20palette%2C%20dynamic%20overlapping%20shapes%2C%20trending%20content%20visual%20metaphor&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                  alt="51吃瓜在线-热门八卦视频聚合平台主视觉"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-accent-400 rounded-2xl flex items-center justify-center shadow-lg transform rotate-6">
                <div className="text-center -rotate-6">
                  <i className="ri-fire-line text-2xl text-background-50"></i>
                  <p className="text-background-50 text-xs font-bold mt-1">HOT</p>
                </div>
              </div>
              <div className="absolute -top-3 -left-3 bg-background-50 rounded-xl px-4 py-2 shadow-md">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                  <span className="text-xs font-bold text-foreground-700 whitespace-nowrap">正在热播</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}